import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'
import { Link } from 'react-router-dom'

export default function Roadmap() {
  return (
    <div className='roadmap relative xl:h-[1788px] lg:h-[2200px] md:h-[2200px] h-[2600px] -z-0 -mt-56 flex justify-center items-center'>
      <div className='absolute top-[10%] left-[0%]'>
        <img
          src='/images/bitcoin-2-gif.gif'
          alt='bitcoin-gif'
          className='lg:w-[480px] md:w-[250px] md:h-[280px] w-[130px] h-[130px] object-contain'
        />
      </div>
      <div className=' flex flex-col justify-center items-center md:pt-44 pt-32'>
        <div>
          <AnimateOnScroll animation='flipIn'>
            <img
              src='/images/roadmap-heading.png'
              alt='about-heading'
              className='md:w-[455px] md:h-[200px] h-[134px] object-contain'
            />
          </AnimateOnScroll>
        </div>
        <div className='ml-20 mt-5 '>
          <AnimateOnScroll animation='flipIn'>
            <Link
              hrefLang='/'
              className='mt-2 block'
            >
              <img
                src='/images/buy-now.png'
                alt='buy-now'
                className='lg:w-[315px] lg:h-[72px] md:h-[70px] h-[40px]'
              />
            </Link>
          </AnimateOnScroll>
        </div>
        <div className='grid xl:grid-cols-3 md:grid-cols-2 gap-20 mt-10 px-10'>
          <div className='border-2 border-red-700  rounded-[70px] relative'>
            <div className='absolute z-50 top-[12%] md:scale-125 scale-105'>
              <AnimateOnScroll animation='flipIn'>
                <img
                  src='/images/phase-1.png'
                  alt='phase'
                  className='lg:w-[360px] lg:h-[40px]'
                />
              </AnimateOnScroll>
            </div>
            <AnimateOnScroll animation='flipIn'>
              <div className='border-t-4 border-l-4  px-8 border-white md:w-[280px] flex flex-col md:justify-center justify-end items-center md:h-[560px] h-[400px] py-10  bg-[#FFC907] text-[22px] text-black rounded-[70px] relative'>
                <div className='md:-translate-y-5'>
                  <p className='text-base'>
                    . Develop and launch the Bitcoin Pizza Day Token
                  </p>
                  <p className='text-base'>
                    . Launch our official website and establish a strong
                    presence on social media platforms to engage with the
                    community.
                  </p>
                  <p className='text-base'>
                    . Run a targeted marketing campaign to spread the word about
                    the Bitcoin Pizza Day Token and its unique concept.
                  </p>
                </div>
              </div>
            </AnimateOnScroll>
          </div>
          <div className='border-2 border-red-700  rounded-[70px] relative'>
            <div className='absolute z-50 top-[12%] md:scale-125 scale-105'>
              <AnimateOnScroll animation='flipIn'>
                <img
                  src='/images/phase-2.png'
                  alt='phase'
                  className='lg:w-[360px] lg:h-[40px]'
                />
              </AnimateOnScroll>
            </div>
            <AnimateOnScroll animation='flipIn'>
              <div className='border-t-4 border-l-4 py-10 px-8 border-white md:w-[280px] flex flex-col justify-end items-end h-[560px] bg-[#FFC907] text-[22px] text-black rounded-[70px] relative'>
                <p className='text-base'>
                  . Get the Bitcoin Pizza Day Token listed on major
                  cryptocurrency exchanges to increase accessibility and
                  liquidity.
                </p>
                <p className='text-base'>
                  . Host special events, including pizza-themed giveaways and
                  contests, to celebrate Bitcoin Pizza Day and engage the
                  community.
                </p>
                <p className='text-base'>
                  . Form strategic partnerships with pizza chains, crypto
                  platforms, and other relevant businesses to expand our reach
                  and utility.
                </p>
                <p className='text-base'>
                  . Provide educational content about cryptocurrency, Bitcoin
                  Pizza Day, and the significance of the token to help
                  onboard new users.
                </p>
              </div>
            </AnimateOnScroll>
          </div>
          <div className='border-2 border-red-700  rounded-[70px] relative'>
            <div className='absolute z-50 top-[12%] md:scale-125 scale-105'>
              <AnimateOnScroll animation='flipIn'>
                <img
                  src='/images/phase-3.png'
                  alt='phase'
                  className='lg:w-[360px] lg:h-[40px]'
                />
              </AnimateOnScroll>
            </div>
            <AnimateOnScroll animation='flipIn'>
              <div className='border-t-4 border-l-4 py-10 px-8 border-white md:w-[280px] flex flex-col md:justify-center justify-end items-center md:h-[560px] h-[450px]   bg-[#FFC907] text-[22px] text-black rounded-[70px] relative'>
                <p className='text-base'>
                  . Introduce advanced features like staking, rewards programs,
                  and voting mechanisms to enhance user engagement and token
                  utility.
                </p>
                <p className='text-base'>
                  . Launch global campaigns to celebrate Bitcoin Pizza Day,
                  promoting the token and its community worldwide.
                </p>
                <p className='text-base'>
                  . Gather feedback from the community and continuously improve
                  the platform, features, and user experience.
                </p>
              </div>
            </AnimateOnScroll>
          </div>
        </div>
        <div className='md:mt-14 mt-14 relative'>
          <div className=' mt-5 absolute lg:bottom-24 md:bottom-16 bottom-10 left-[15%] z-50'>
            <AnimateOnScroll animation='flipIn'>
              <Link
                hrefLang='/'
                className='mt-2 block'
              >
                <img
                  src='/images/buy-now.png'
                  alt='buy-now'
                  className='lg:w-[315px] lg:h-[72px] md:h-[70px] h-[40px]'
                />
              </Link>
            </AnimateOnScroll>
          </div>
          <AnimateOnScroll animation='flipIn'>
            <img
              src='/images/join-us.png'
              alt='phase'
              className='lg:w-[980px] lg:h-[350px] md:w-[650px] w-[350px]'
            />
          </AnimateOnScroll>
        </div>
      </div>
      <div className='absolute xl:bottom-[8rem] md:bottom-[7%] bottom-[7%] '>
        Copyright © 2024 Bitcoin Pizza. All Rights Reserved
      </div>
      <div className='absolute md:right-5 xl:bottom-32 md:bottom-[8%] bottom-5 right-[35.5%%] flex items-center gap-2'>
        <Link hrefLang='/'>
          <img
            src='/images/telegram.png'
            alt='twitter'
            width={50}
            height={50}
          />
        </Link>
        <Link
          hrefLang='/'
          className=' block'
        >
          <img
            src='/images/twitter.png'
            alt='twitter'
            width={50}
            height={50}
          />
        </Link>
      </div>
    </div>
  )
}
